// src/services/pdfFonts.js
//
// Single source of truth for the TTF faces embedded into @react-pdf documents
// (certificates + reports).
//
// WHY LOCAL FILES (not a CDN): @react-pdf can only embed real .ttf/.otf — it
// cannot parse woff/woff2. fontsource v5 stopped shipping .ttf (woff/woff2
// only), so the old `cdn.jsdelivr.net/npm/@fontsource/...-normal.ttf` URLs all
// return 404 and every PDF render rejected ("Failed to fetch font ... 404").
// We self-host the real TTFs in public/fonts/ instead; they are served
// same-origin in dev (CRA) and prod (nginx serves the CRA build), so PDF
// generation never depends on an external CDN again.
//
// Files come from the upstream OFL releases (Google Fonts) and live in
// al-bayan-quran-tracker/public/fonts/. Keep this list and that folder in sync
// — `reportFonts.test.js` asserts every src here is local and present.

export const AMIRI_REGULAR = '/fonts/Amiri-Regular.ttf';
export const AMIRI_BOLD = '/fonts/Amiri-Bold.ttf';
export const AREF_REGULAR = '/fonts/ArefRuqaa-Regular.ttf';
export const AREF_BOLD = '/fonts/ArefRuqaa-Bold.ttf';

// Filenames expected under public/fonts/ (used by tests to verify presence).
export const REQUIRED_PDF_FONT_FILES = [
  'Amiri-Regular.ttf',
  'Amiri-Bold.ttf',
  'ArefRuqaa-Regular.ttf',
  'ArefRuqaa-Bold.ttf',
];

export const AMIRI_FONTS = [
  { src: AMIRI_REGULAR, fontWeight: 'normal' },
  { src: AMIRI_BOLD, fontWeight: 'bold' },
];

export const AREF_FONTS = [
  { src: AREF_REGULAR, fontWeight: 'normal' },
  { src: AREF_BOLD, fontWeight: 'bold' },
];
